export default {
  development: {
    SOCKETIO_newlogin: "newlogin" ,
    SOCKETIO_loggedin: "loggedin",
    // SOCKETIO_newlogin: "newlogin_uat" ,
    // SOCKETIO_loggedin: "newlogin_uat",
    IDLE_TIMEOUT: 2 * 60 * 60 * 1000, // 2Hr
    LEAFTECH_HOST: "https://maps.leafte.ch",
    // BACKEND_HOST: "https://digital.map.api.dev.rtic-thai.info/api/v1", // TDEM
    // BACKEND_HOST: "https://digital.map.api.rtic-thai.info/api/v1",  // NETH
    //BACKEND_HOST: "https://digital.map.api.dev.rtic-thai.info/api/v1", // NETH
    BACKEND_HOST: "https://digital.map.lsp.web.api.nexty.rtic-thai.info/api/v1",
    //SOCKETIO_URL: "https://digital.map.api.dev.rtic-thai.info",
    SOCKETIO_URL: "https://digital.map.lsp.web.api.nexty.rtic-thai.info", 
    // BACKEND_HOST : "http://dm_dev1.leafte.ch:8888/https://digital.map.api.rtic-thai.info/api/v1", 
    // BACKEND_HOST: "http://digital.map.api.dev.rtic-thai.info:6001/api/v1",
    //BACKEND_HOST: "http://digital.map.api.dev.rtic-thai.info:5000/api/v1",
    CANDIDATE_HOST : "http://digital.map.route.rtic-thai.info/odRouting",
    REROUTE_HOST : "http://digital.map.route.rtic-thai.info/sfvrp",
    //CANDIDATE_HOST : "https://tsq2.leafte.ch/odRouting",
    //CANDIDATE_HOST : "http://beta.tsq.api.rtic-thai.info/odRouting",
    //CANDIDATE_HOST : "http://digital.map.route.rtic-thai.info/odRouting",
    AUTHORIZATION : "1234567890-12345-12345678",
    MAP_KEY : "AIzaSyAWQwbZgCqup0ivtwF-l1OFLPt_AKqGYzQ"
  },
  production: {
    IDLE_TIMEOUT: 2 * 60 * 60 * 1000, // 2Hr
    BACKEND_HOST: "https://digital.map.lsp.api.web.rtic-thai.info/api/v1",
    AUTHORIZATION : "1234567890-12345-12345678",
    SOCKETIO_URL: "https://digital.map.lsp.api.web.rtic-thai.info",
    CANDIDATE_HOST : "https://waypoint.digital.map.lsp.web.api.rtic-thai.info/v0.1/waypoint-routing",
    REROUTE_HOST : "https://waypoint.digital.map.lsp.web.api.rtic-thai.info/v0.1/waypoint-routing",
    MAP_KEY : "AIzaSyAR8tDtV_F2TuYSqZHAkdAzG7g8Hif8Cz8"
  }
};